export const LOCAL_STORAGE_KEYS = {
  confidentiality_disclaimer: 'confidentiality_disclaimer',
  third_party_auth_route_to_redirect: 'third_party_auth_route_to_redirect',
  settings: 'settings',
  app_store_tab: 'appStoreTab',
  token: 'token',
  block_library_clipboard: 'block_library_clipboard',
  block_library_clipboard_space_id: 'block_library_clipboard_space_id',
  preview_breakpoint: 'preview_breakpoint',
  preview_width: 'preview_width',
} as const

export default LOCAL_STORAGE_KEYS
